import { actionTypes, getterTypes, mutationTypes, routesNames, situacoes } from '@/core/constants'
import SalvarItensAdesaoInput from '@/core/apiclient/adesao/models/SalvarItensAdesaoInput'
import { mapGetters } from 'vuex'
import FluxoProcesskey from '@/core/constants/fluxo-processkey'
import { AzBpmProcess } from '@azinformatica/loki'

export default {
	data() {
		return {
			businessKey: `${this.$route.params.id}`,
			process_key: this.$store.getters[getterTypes.COMUM.GET_CAMUNDA_PROCESS_KEY](FluxoProcesskey.ADESAO),
			process_key_externa: this.$store.getters[getterTypes.COMUM.GET_CAMUNDA_PROCESS_KEY](FluxoProcesskey.ADESAO_EXTERNA),
			process: null,
		}
	},
	computed: {
		...mapGetters({
			getCurrentTaskBpmn: getterTypes.COMUM.GET_CURRENT_TASK,
			informacoesOcorrencia: getterTypes.OCORRENCIA.GET_INFORMACOES_OCORRENCIA,
			getStatusInstance: getterTypes.COMUM.GET_STATUS_INSTANCE,
		}),
		informacoesAdesao() {
			return this.$store.state.adesao.informacoesAdesao || {}
		},
		isConcluida() {
			return this.informacoesAdesao.situacao === situacoes.ADESAO.CONCLUIDO.value
		},
		estaRecusada() {
			return this.informacoesAdesao.situacao === situacoes.ADESAO.RECUSADO.value
		},
		isAdesaoExterna() {
			return !!this.informacoesAdesao.adesaoExterna
		},
		temPermissao() {
			if (this.process) return this.process.hasAuthority()
			if (this.isAdesaoExterna && !this.informacoesAdesao.utilizaFluxo) {
				return this.informacoesAdesao.usuarioEhGestor
			}
			return false
		},
		isAdesaoAceita() {
			const situacoesAceitas = [situacoes.ADESAO.ACEITO.value, situacoes.ADESAO.CONCLUIDO.value]
			return situacoesAceitas.includes(this.informacoesAdesao.situacao)
		},
		isFluxoFinalizado() {
			if (this.informacoesAdesao.utilizaFluxo) {
				const processKey = this.getProcessKeyAtual()
				const statusInstance = this.getStatusInstance(processKey, this.businessKey)
				return statusInstance === 'ENDED'
			}
			return false
		},
	},
	methods: {
		async redirecionarParaAdesao(id, tipoAcesso) {
			await this.$router.push({
				name: routesNames.ADESAO.ADESAO_VIEW,
				params: { id: id, tipoAcesso: tipoAcesso },
			})
		},
		getParamsListagem() {
			return {
				filtro: {
					idAta: {
						default: null,
						label: '',
						value: this.$route.params.id,
					},
				},
				paginacao: this.paginacao,
			}
		},
		getProcessKeyAtual() {
			if (this.isAdesaoExterna && this.informacoesAdesao.utilizaFluxo) {
				return this.process_key_externa
			}
			return this.process_key
		},
		async atualizaInstanciaDoProcesso(obj) {
			if (this.informacoesAdesao.utilizaFluxo) {
				const processKey = this.getProcessKeyAtual()
				this.process = new AzBpmProcess(this.$store, processKey, this.businessKey)
				await this.process.load()
				this.processInstance = this.process.getProcess().instance
				this.componentes = this.process.getComponents()
				await this.alterarTramitacaoOcorrencia(obj)
			}
		},
		async alterarTramitacaoOcorrencia(resultadoAcao) {
			if (resultadoAcao && !resultadoAcao.error) {
				const payload = this.criarPayloadOcorrencia(resultadoAcao)
				await this.$store.dispatch(actionTypes.OCORRENCIA.ATUALIZAR_OCORRENCIA, payload)
			}
		},
		isPermissaoAutorizada(permissao) {
			const processKey = this.getProcessKeyAtual()
			const currentTask = this.getCurrentTaskBpmn(processKey, this.businessKey)

			if (currentTask) {
				const partes = currentTask.revokedPermissions.split(',')
				for (const parte of partes) {
					if (parte.includes(permissao)) {
						return false
					}
				}
			}
			return true
		},
		estaEmElaboracao(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.ADESAO.EM_ELABORACAO.value
				}
				return value.situacao === situacoes.ADESAO.EM_ELABORACAO.value
			}
			return false
		},
		async carregarAdesao(idAdesao) {
			const adesao = await this.$store.dispatch(actionTypes.ADESAO.BUSCAR_POR_ID, idAdesao)
			this.$store.commit(mutationTypes.ADESAO.SET_INFORMACOES_ADESAO, adesao)
			return adesao
		},
		async salvarItensAdesao(idAdesao) {
			const input = new SalvarItensAdesaoInput(idAdesao)
			return await this.$store.dispatch(actionTypes.ADESAO.SALVAR_ITENS, input)
		},
		criarPayloadOcorrencia(resultadoAcao) {
			return {
				idEntidade: this.informacoesOcorrencia.idEntidade,
				entidadeTipo: this.informacoesOcorrencia.tipoEntidade,
				acao: resultadoAcao.action,
			}
		},
	},
}
